console.log("Discovery JS loaded");


(function () {
    const DISCOVERY = {
        randomUrl: "/random/",
        fallbackUrl: "/toc/",
        hiddenTag: "hash-hidden"
    };

    async function goToRandomSelected() {
        try {
            const apiKey = window.contentApiKey;

            if (!apiKey) {
                throw new Error("Missing Ghost Content API key.");
            }

            const apiUrl =
                "/ghost/api/content/posts/?" +
                "key=" + encodeURIComponent(apiKey) +
                "&limit=all" +
                "&fields=url,title" +
                "&filter=tag:-" + DISCOVERY.hiddenTag;

            const response = await fetch(apiUrl);

            if (!response.ok) {
                throw new Error("Ghost Content API request failed.");
            }

            const data = await response.json();
            const posts = data.posts || [];

            if (!posts.length) {
                window.location.href = DISCOVERY.fallbackUrl;
                return;
            }

            const randomPost = posts[Math.floor(Math.random() * posts.length)];
            window.location.href = randomPost.url;
        } catch (error) {
            console.error("Random failed:", error);
            window.location.href = DISCOVERY.fallbackUrl;
        }
    }

    document.addEventListener("click", function (event) {
        const link = event.target.closest("a");
        if (!link) {
            return;
        }
        const url = new URL(link.href);

        if (url.pathname !== DISCOVERY.randomUrl) {
            return;
        }
        event.preventDefault();
        console.log("Random clicked");


        goToRandomSelected();

        // 6377519d2cc77b19e0fd7d1993
    });
})();